import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authSlice";

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Optional list of roles that are allowed to access this route. */
  roles?: string[];
}

/**
 * ProtectedRoute — redirects unauthenticated users to /login
 * and unauthorized users (wrong role) to /dashboard.
 */
export default function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);

  // Not logged in → redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role check (if required)
  if (roles && roles.length > 0) {
    const hasRequiredRole = roles.some((role) => user.roles.includes(role));
    if (!hasRequiredRole) {
      return (
        <div className="flex items-center justify-center h-screen bg-gray-50">
          <div className="text-center max-w-sm">
            <div className="h-16 w-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">⛔</span>
            </div>
            <h2 className="text-lg font-bold text-gray-900 mb-2">Akses Ditolak</h2>
            <p className="text-sm text-gray-500 mb-4">
              Anda tidak memiliki izin untuk mengakses halaman ini.
              Diperlukan peran: <strong>{roles.join(", ")}</strong>.
            </p>
            <Navigate to={user.roles.includes("GUEST") ? "/documents" : "/dashboard"} replace />
          </div>
        </div>
      );
    }
  }

  return <>{children}</>;
}
